import {EmailSchema} from '@cohort/shared/schema/common';
import {z} from 'zod';

function stringToBoolean(val: string): boolean {
  return JSON.parse(val.toLocaleLowerCase());
}

export const InitParamsWSchema = z.object({
  authToken: z.string().optional(),
  cohortRedirect: z.string().optional(),
  disableLogout: z.string().transform(stringToBoolean).optional(),
  email: EmailSchema.optional(),
  embedded: z.string().transform(stringToBoolean).optional(),
  embedEmail: EmailSchema.optional(),
  embedUrl: z.string().optional(),
  integrationType: z.string().optional(),
  navbar: z.string().transform(stringToBoolean).optional(),
  navigationType: z.string().optional(),
  otpCode: z.string().optional(),
  shopifyAppPath: z.string().optional(),
  shopifyLoginPath: z.string().optional(),
  shopifyShopUrl: z.string().optional(),
  tokenId: z.coerce.number().optional(),
  userMenu: z.string().transform(stringToBoolean).optional(),
});
export type InitParamsWDto = z.infer<typeof InitParamsWSchema>;
